import { useEffect, useMemo } from 'react'
import { replaceAllLinks, replaceQuotedStringsWithNl } from 'helpers/editor'
import textile from 'lib/textile-js/textile-js' // textile расположено локально. убран функционал замены символов в верхнем регистре в тег span
import { InputLabel } from 'ui/components/forms/Input/styled'
import { Preview } from './styled'

const EditorPreview = ({ label, editorVersion = 0, value = '' }) => {
  const newVal = useMemo(() => {
    if (value) {
      switch (editorVersion) {
        case 1:
          return textile.parse(
            replaceAllLinks(replaceQuotedStringsWithNl(value))
          )
        default:
          return value
      }
    }

    return ''
  }, [value])

  useEffect(() => {
    Array.from(document.getElementsByClassName('editorPreview'))?.map((i) =>
      Array.from(i.getElementsByTagName('a'))?.forEach((i) => {
        i.target = '_blank'
        if (editorVersion === 1) {
          if (i.innerHTML.length > 30) {
            i.style.cssText = 'word-break: break-all;'
          }
        }
      })
    )
  }, [value])

  return (
    <Preview className="editorPreview">
      {label && <InputLabel>{label}</InputLabel>}
      <div
        style={{
          lineHeight: '1.7em',
        }}
        dangerouslySetInnerHTML={{ __html: newVal }}
      />
    </Preview>
  )
}

export default EditorPreview
